/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Blocklist_TitleInputs */

const en_carrier_blocklist_title = /** @type {(inputs: Carrier_Blocklist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier Blocklist`)
};

const es_carrier_blocklist_title = /** @type {(inputs: Carrier_Blocklist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de bloqueo de transportistas`)
};

/**
* | output |
* | --- |
* | "Carrier Blocklist" |
*
* @param {Carrier_Blocklist_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_blocklist_title = /** @type {((inputs?: Carrier_Blocklist_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Blocklist_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_blocklist_title(inputs)
	return es_carrier_blocklist_title(inputs)
});